import React from "react";
import ReadAloud from "@/components/ReadAloud";

export default function PageHeader({ title, subtitle, screen, getContext, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
      <div className="min-w-0">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight truncate">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {children}
        <ReadAloud screen={screen} getContext={getContext} />
      </div>
    </div>
  );
}
